module.exports = "\n            <div #sideBarContent></div>\n"